import React, { useState } from 'react';
import styled from 'styled-components';
import { useTheme } from '../../context/ThemeContext';
import { getTheme } from '../../theme';
import JobsList from './JobsList';
import ScheduledNotificationsView from './ScheduledNotificationsView';

const TabsContainer = styled.div`
  display: flex;
  gap: ${props => getTheme(props.theme?.isDark).spacing.sm};
  border-bottom: 1px solid ${props => getTheme(props.theme?.isDark).colors.border};
  margin-bottom: ${props => getTheme(props.theme?.isDark).spacing.lg};
`;

const Tab = styled.button`
  padding: ${props => getTheme(props.theme?.isDark).spacing.md} ${props => getTheme(props.theme?.isDark).spacing.lg};
  background: transparent;
  border: none;
  border-bottom: 2px solid ${props => props.active
    ? getTheme(props.theme?.isDark).colors.primary
    : 'transparent'};
  color: ${props => props.active
    ? getTheme(props.theme?.isDark).colors.primary
    : getTheme(props.theme?.isDark).colors.textSecondary};
  font-size: 14px;
  font-weight: ${props => props.active ? 600 : 400};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    color: ${props => getTheme(props.theme?.isDark).colors.primary};
  }
`;

const JobsPage = () => {
  const { isDark } = useTheme();
  const theme = { isDark };
  const [activeTab, setActiveTab] = useState('all');

  return (
    <>
      <TabsContainer theme={theme}>
        <Tab
          active={activeTab === 'all'}
          onClick={() => setActiveTab('all')}
          theme={theme}
        >
          All Jobs
        </Tab>
        <Tab
          active={activeTab === 'scheduled'}
          onClick={() => setActiveTab('scheduled')}
          theme={theme}
        >
          Scheduled Notifications
        </Tab>
      </TabsContainer>

      {activeTab === 'all' && <JobsList />}
      {activeTab === 'scheduled' && <ScheduledNotificationsView />}
    </>
  );
};

export default JobsPage;










